/*eslint-disable*/
import * as yup from 'yup';
import { FileUtil, FormValidationUtil, DateUtil } from '../../../utils';

const initialValues = {
  leaveType: '',
  leaveFromDate: '',
  leaveToDate: '',
  reasonForLeave: '',
  altrBackupPlan: '',
  comments: '',
  leaveFromTime: '',
  leaveToTime: '',
  delegateApprover: 0,
  entitledDays: 0,
  usedDays: 0,
  balanceDays: 0,
  extraDays: 0,
  attachmentPath: '',
  file: [],
  emergencyContact: '',
};

const validationSchema = yup.object().shape({
  leaveType: yup.string().required('Leave type is required'),
  leaveFromDate: yup
    .date()
    .typeError('Leave from date is required')
    .required('Leave from date is required')
    .nullable(),
  leaveToDate: yup
    .date()
    .typeError('Leave to date is required')
    .required('Leave to date is required')
    .nullable(),
  reasonForLeave: yup.string().required('Reason for leave is required'),
  altrBackupPlan: yup.string().required('Alternative/Backup plan is required'),
  comments: yup.string().optional(),
  leaveFromTime: yup.string().optional(),
  leaveToTime: yup.string().optional(),
  delegateApprover: yup.mixed().optional(),
  entitledDays: yup.number().required('Entitled days are required'),
  usedDays: yup.number().optional(),
  balanceDays: yup.number().required('Balance days are required'),
  extraDays: yup.number().optional(),
  attachmentPath: yup.string().optional(),
  file: yup
    .array()
    .min(1, 'Attachment is required')
    .test(
      'fileSize',
      `File size must be less than ${FileUtil.DEFAULT_ATTACHMENT_SIZE_MB}MB`,
      FormValidationUtil.validateMultipleFilesSize(
        FileUtil.DEFAULT_ATTACHMENT_SIZE_B,
      ),
    )
    .test(
      'fileFormat',
      FormValidationUtil.validateMultipleFilesFormatMessage(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
      FormValidationUtil.validateMultipleFilesFormat(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
    ),
  emergencyContact: yup.string().required('Emergency Contact is required'),
});

const validateLeaveSchema = yup.object().shape({
  leaveType: yup.string().required('Leave type is required'),
  leaveFromDate: yup
    .date()
    .typeError('Leave from date is required')
    .required('Leave from date is required')
    .nullable(),
  leaveToDate: yup
    .date()
    .typeError('Leave to date is required')
    .required('Leave to date is required')
    .nullable(),
  reasonForLeave: yup.string().required('Reason for leave is required'),
  altrBackupPlan: yup.string().required('Alternative/Backup plan is required'),
  comments: yup.string().optional(),
  leaveFromTime: yup.string().optional(),
  leaveToTime: yup.string().optional(),
  delegateApprover: yup.mixed().optional(),
  entitledDays: yup.number().required('Entitled days are required'),
  usedDays: yup.number().optional(),
  balanceDays: yup.number().required('Balance days are required'),
  extraDays: yup.number().optional(),
  attachmentPath: yup.string().optional(),
  file: yup.array().optional(),
  emergencyContact: yup.string().required('Emergency Contact is required'),
});

export const populateFormValues = data => ({
  leaveType: data.LvTyp.trim() || '',
  leaveFromDate: DateUtil.formatDateTimeToHtmlDate(data?.FromDt) || '',
  leaveToDate: DateUtil.formatDateTimeToHtmlDate(data?.ToDt) || '',
  delegateApprover: data?.DelegateApprover
    ? {
        value: data.DelegateApprover,
        label: data.DelegateApproverName || '',
      }
    : null,
  reasonForLeave: data?.Reason || '',
  altrBackupPlan: data?.AltrBackupPlan || '',
  comments: data?.Comments || '',
  leaveFromTime: data?.FromTime
    ? DateUtil.convertTimeToHTMLTimeRegex(data.FromTime)
    : '',
  leaveToTime: data?.ToTime
    ? DateUtil.convertTimeToHTMLTimeRegex(data.ToTime)
    : '',
  attachmentPath: data?.AttachmentPath || '',
  emergencyContact: data?.Emergency_Contact || '',
});

const leaveHistory = {
  'Annual Leave': 0,
  'Birthday Leave': 0,
  'Casual Leave': 0,
  'Maternity/Paternity Leave': 0,
  'Sick Leave': 0,
  'Study Leave': 0,
  'Unpaid Leave': 0,
  'Other Time Off': 0,
};

const halfDayLeaveTypes = ['AH', 'SH', 'CH', 'UH'];

const appliedLeaveDataConfig = [
  {
    key: 'Leave Type',
    label: 'Leave Type',
    type: 'text',
  },
  {
    key: 'From Date',
    label: 'From Date',
    type: 'text',
  },
  {
    key: 'To Date',
    label: 'To Date',
    type: 'text',
  },
  {
    key: 'Days',
    label: 'Days',
    type: 'text',
  },
];

const departmentDataConfig = [
  {
    key: 'Leave Type',
    label: 'Leave Type',
    type: 'text',
  },
  {
    key: 'Employee',
    label: 'Employee',
    type: 'text',
  },
  {
    key: 'From Date',
    label: 'From Date',
    type: 'text',
  },
  {
    key: 'To Date',
    label: 'To Date',
    type: 'text',
  },
  {
    key: 'Days',
    label: 'Days',
    type: 'text',
  },
  {
    key: 'Reason',
    label: 'Reason',
    type: 'text',
  },
];

export {
  initialValues,
  validationSchema,
  validateLeaveSchema,
  leaveHistory,
  halfDayLeaveTypes,
  appliedLeaveDataConfig,
  departmentDataConfig,
};
